export default {"src":"/_next/static/media/cultural_routes.761ca08d.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};